/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:25
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers')
    .controller('DialogCtrl', ["$scope", "$rootScope", "dialog", "dialogsModel","$document", "LanguageManager", "Brand",
        function($scope,$rootScope,dialog,dialogsModel,$document, LanguageManager, Brand) {
            var key;
            // hook the passed data to the popin scope
            for (key in dialogsModel) {
                $scope[key] = dialogsModel[key];
            }

            //Mock for Oui/Non toggle buttons
            $scope.isEnglishLanguage = function () {
                return LanguageManager.isEnglishLanguage();
            };

            $scope.dialog = dialog;
            $scope.cancel = function(){
                dialog.close(false);
            };
            $scope.action = function(){
                dialog.close(true);
            };

            $scope.confirm = function(params){
                dialog.close(params);
            };

            $scope.brand = Brand;
    }]);


// WEBPACK FOOTER //
// ./js/controllers/pro/dialog/DialogCtrl.js